// Client-side guards that mirror the API's media limits for videos
// (mindfeed-api src/forms/models/media.rs): max 1 GB, and only MP4, MPEG, and
// QuickTime (.mov) are accepted. Catching these before upload gives immediate
// feedback instead of a failed request.
export const MAX_VIDEO_BYTES = 1024 * 1024 * 1024; // 1 GB (1024^3)

export const ACCEPTED_VIDEO_TYPES = [
  'video/mp4',
  'video/mpeg',
  'video/quicktime',
];

export interface VideoFileValidation {
  accepted: File[];
  errors: string[];
}

export const validateVideoFiles = (files: File[]): VideoFileValidation => {
  const accepted: File[] = [];
  const errors: string[] = [];

  files.forEach((file) => {
    if (!ACCEPTED_VIDEO_TYPES.includes(file.type)) {
      errors.push(
        `${file.name} isn't a supported video format. Use MP4, MPEG, or MOV.`,
      );
    } else if (file.size > MAX_VIDEO_BYTES) {
      errors.push(`${file.name} is larger than 1 GB, the maximum video size.`);
    } else {
      accepted.push(file);
    }
  });

  return { accepted, errors };
};
